import React from "react";
import classNames from "classnames";
import { TransactionListItemDto } from "../../../common/types/transaction";
import { useCategoriesById } from "../../../hooks/useCategoriesById";
import { CategoryIcon } from "../CategoryIcon";
import styles from "./TransactionDescriptionColumnContent.module.scss";

interface Props {
    transaction: TransactionListItemDto;
}

export const TransactionCategoryColumnContent: React.FC<Props> = ({
    transaction,
}) => {
    const categoriesById = useCategoriesById();

    return (
        <div className={classNames("gap-2", styles.content)}>
            <CategoryIcon categoryId={transaction.categoryId} />
            {categoriesById[transaction.categoryId]?.label}
        </div>
    );
};
